import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { BookingProvider } from '../../contexts/BookingContext';
import { BookingDetailsProvider } from '../../contexts/BookingDetailsContext';
import Bookings from './Bookings';
import BookingDetails from './BookingDetails';

const BookingDetailsWrapper = React.memo(() => {
  return (
    <BookingDetailsProvider>
      <BookingDetails />
    </BookingDetailsProvider>
  );
});

const BookingBase = () => (
    <BookingProvider>
        <Routes>
            <Route path="/" element={<Bookings />} />
            <Route path=":id" element={<BookingDetailsWrapper />} />
        </Routes>
    </BookingProvider>
);

export default BookingBase;
